export const EAGLES_REF = ['UofF', 'Shands', 'HardinCounty']
